<section>
  <h1 class="center">{{ porteur.porteur }}</h1>
  <nav>
    <a routerLinkActive="active-link" routerLink="./dotation">Dotation</a>
    <a routerLinkActive="active-link" routerLink="./mutation">Mutation</a>
    <a routerLinkActive="active-link" routerLink="./marquage">Marquage*</a>
  </nav>
</section>
<router-outlet></router-outlet>
